import type { OddsModel } from '@nf/types/odds';
import { Maybe, identity } from '@nf/utils-common/fpw/monadic';
import { stringEmptyCheck, esSetEmptyCheck } from '@nf/utils-common/fpw/utils';
import { getKeyByValue } from '@nf/utils-common/utils';
import { menuDefinition } from '@/types/menu-setting';
import { BehaviorSubject } from 'rxjs';

// menuType example: "M12"
const pickMenuTypeCode = (menuType: string) => Number(menuType.substring(1));

const getFilteredOddsLeaguesByMode = (
	oddsModel: OddsModel | null, 
	oddsLeagues: Map<number, string>, 
	mode: string
) => {
	let oddsLeaguesClone = new Map(oddsLeagues);

	stringEmptyCheck(mode)
		.fork({
			just: () => {
				const oddsDataLeagueIdsByMenuType = (oddsModel?.MatchCollection ?? [])
					.filter(match => {
						const menuTypeKey: number = 
							Maybe(getKeyByValue(menuDefinition, mode))
								.map(pickMenuTypeCode)
								.fold(
									() => 0,
									identity
								);
						return match.LDM === menuTypeKey;
					})
					.map(match => match.LeagueId);
				const oddsDataLeagueIdsSetByMenuType = new Set(oddsDataLeagueIdsByMenuType);
				
				oddsLeaguesClone = esSetEmptyCheck(oddsDataLeagueIdsSetByMenuType)
					.fold(
						() => new Map<number, string>(),
						() => new Map(
							[...oddsLeaguesClone].filter(
								([leagueId]) => oddsDataLeagueIdsSetByMenuType.has(leagueId)
							)
						)
					);
			},
			none: () => {}
		});

	return oddsLeaguesClone;
};

const isAllLeagueExpand$ = new BehaviorSubject(true);
const setIsAllLeagueExpand = (isExpand: boolean) => isAllLeagueExpand$.next(isExpand);

export const leagueService = {
	getFilteredOddsLeaguesByMode,
	isAllLeagueExpand$: isAllLeagueExpand$.asObservable(),
	setIsAllLeagueExpand,
};